import { setBlockType } from 'prosemirror-commands';
import type { NodeSpec, Node as ProsemirrorNode } from 'prosemirror-model';
import type { MarkdownSerializerState } from '../lib/markdown/serializer';
import type { NodeOptions } from './Node';
import Node from './Node';

export default class Paragraph extends Node {
	get name() {
		return 'paragraph';
	}

	get schema(): NodeSpec {
		return {
			content: 'inline*',
			group: 'block',
			selectable: false,
			parseDOM: [{ tag: 'p' }],
			toDOM: () => ['p', 0],
		};
	}

	keys({ type }: NodeOptions) {
		return {
			'Shift-Ctrl-0': setBlockType(type),
		};
	}

	commands({ type }: NodeOptions) {
		return () => setBlockType(type);
	}

	toMarkdown(state: MarkdownSerializerState, node: ProsemirrorNode) {
		// Render empty paragraphs as hard breaks to ensure that newlines are
		// persisted between reloads (this breaks from markdown tradition)
		if (
			node.textContent.trim() === '' &&
			node.childCount === 0 &&
			!state.inTable
		) {
			state.write('\\\n');
		} else {
			state.renderInline(node);
			state.closeBlock(node);
		}
	}

	parseMarkdown() {
		return { block: 'paragraph' };
	}
}
